import { useEffect } from "react";
import dayjs from "dayjs";
import 'dayjs/locale/es';
import 'dayjs/locale/pt';
import 'dayjs/locale/fr';
import { useTranslation } from "react-i18next";

export const useDayjsLocal = () => {
    const { i18n } = useTranslation();
    const language = localStorage.getItem('language');
    dayjs.locale(language || 'en');
    
    useEffect(() => {
        const onLanguageChange = (lang: string) => {
            dayjs.locale(lang);
        };

        i18n.on('languageChanged', onLanguageChange);

        return () => {
            i18n.off('languageChanged', onLanguageChange);
        };
    }, [i18n]);
};